"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};


// WEBPACK FOOTER //
// ../~/material-ui/utils/autoPrefix.js